<div>
  <button class="w-full text-left cursor-pointer" (click)="logout()">
    <span
      class="flex items-center px-4 py-3 text-sm font-medium text-red-700 hover:bg-red-50 hover:text-red-800 gap-2 duration-250 ease-in-out">
      <span class="material-symbols-outlined text-[18px] leading-none">logout</span>
      <span>Se déconnecter</span>
    </span>
  </button>
</div>
